import { useHistory } from "react-router-dom";
import { AdminLayout } from "../components/AdminLayout";
import { XForm } from "../components/Form";
import { ScreenHeader } from "../components/ScreenHeader";

import * as service from "../services/katalog-prac.service";

export const EditKatalogPracScreen = ({ location: { state } }) => {
  const history = useHistory();

  return (
    <AdminLayout>
      <>
        <ScreenHeader
          withBackButton
          breadcrumbs={["Panel", "Katalog prac", "Edytuję - " + state.title_pl]}
        />

        <XForm
          data={state}
          onSubmit={(data) => {
            service
              .updateKatalogPracItem(state.id, data)
              .then((_) => history.goBack());
          }}
        />
      </>
    </AdminLayout>
  );
};
